import axios from 'axios'
import {apiEndpoints, SERVER_PATH} from '../endpoints.js'

const resetCache = async () => {
	const URL = SERVER_PATH + apiEndpoints.resetCache
	axios.post(URL, {}, {withCredentials: true});
}

export default resetCache
